<template>
    <div>
      <Header />
      <v-container>
          <v-alert type="error" v-if="error">{{ error }}</v-alert>
        <v-row justify="center" align="center" fill-height>
          <v-col cols="6" xl="6">
            <v-card :loading="loading">
              <v-container>
                <v-card-title>DPD Rechnungs CSV hochladen</v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                        <v-col cols="10">
                            <v-file-input
                            outlined
                            show-size
                            accept="text/csv"
                            label="DPD CSV Datei"
                            v-model="dpdFiles"
                            :loading="uploadingState == 2"
                            :success="uploadingState == 1"
                            ref="file"
                            multiple
                            ></v-file-input>
                        </v-col>
                        <v-col cols="2">
                            <v-btn large @click="uploadDPDInvoices" color="primary">Hochladen</v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col v-if="dpdFiles">
                            <v-data-table
                            :loading="loading"
                            :headers="headers"
                            :items="dpdFiles"
                            item-key="name"
                            class="elevation-1"
                            ></v-data-table>
                        </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-container>
            </v-card>
          </v-col>
          <v-col cols="6" xl="6">
            <v-card :loading="loading">
              <v-container>
                <v-card-title>DHL Rechnungs CSV hochladen</v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                        <v-col cols="10">
                            <v-file-input
                            outlined
                            show-size
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            label="DHL XLSX Datei"
                            v-model="dhlFiles"
                            :loading="uploadingState == 2"
                            :success="uploadingState == 1"
                            ref="file"
                            multiple
                            ></v-file-input>
                        </v-col>
                        <v-col cols="2">
                            <v-btn large @click="uploadDHLInvoices" color="primary">Hochladen</v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col v-if="dhlFiles">
                            <v-data-table
                            :loading="loading"
                            :headers="headers"
                            :items="dhlFiles"
                            item-key="name"
                            class="elevation-1"
                            ></v-data-table>
                        </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </template>

<script>
import Header from "@/views/general/header";
import router from "@/plugins/router";

import CarrierInvoiceService from "@/services/CarrierInvoiceService";

export default {
    name: "dashboard",
    components: {
        Header: Header
    },
    data: () => ({
        loading: true,
        error: null,
        dpdFiles: [],
        dhlFiles: [],
        uploadingState: 0,
        headers: [
            { text: "Name", value: "name" },
            { text: "Size", value: "size" },
            { text: "Hochgeladen", value: "success" },
            { text: "Fehlgeschlagen", value: "failed" }
        ]
    }),
    mounted() {
        this.refresh();
    },
    methods: {
        async uploadDPDInvoices() {
            this.uploadingState = 2;
            this.loading = true;
            let uploadFiles = [...this.dpdFiles];
            this.dpdFiles = [];
            for(let i = 0; i < uploadFiles.length; i++) {
                this.dpdFiles.push({
                    name: uploadFiles[i].name,
                    size: uploadFiles[i].size / 1024 + " KB",
                    success: "Ausstehend",
                    failed: ""
                });
            }

            for(let i = 0; i < uploadFiles.length; i++) {
                console.log("Uploading", this.dpdFiles[i])
                this.dpdFiles[i].success = "Upload läuft..."
                let formData = new FormData();
                formData.set("file", uploadFiles[i]);
                try {
                    let response = (await CarrierInvoiceService.uploadDPD(formData)).data;
                    
                    this.dpdFiles[i].success = response.successRecords || 0;
                    this.dpdFiles[i].failed = response.failedRecords || 0;
                } catch (err) {
                    this.dpdFiles[i].failed = "Alle";
                    console.error(err);
                }
            }
            this.loading = false;
            this.uploadingState = 0;
          
        },
        async uploadDHLInvoices() {
            this.uploadingState = 2;
            this.loading = true;
            let uploadFiles = [...this.dhlFiles];
            this.dhlFiles = [];
            for(let i = 0; i < uploadFiles.length; i++) {
                this.dhlFiles.push({
                    name: uploadFiles[i].name,
                    size: uploadFiles[i].size / 1024 + " KB",
                    success: "Ausstehend",
                    failed: ""
                });
            }

            for(let i = 0; i < uploadFiles.length; i++) {
                console.log("Uploading", this.dhlFiles[i])
                this.dhlFiles[i].success = "Upload läuft..."
                let formData = new FormData();
                formData.set("file", uploadFiles[i]);
                try {
                    let response = (await CarrierInvoiceService.uploadDHL(formData)).data;
                    
                    this.dhlFiles[i].success = response.successRecords || 0;
                    this.dhlFiles[i].failed = response.failedRecords || 0;
                } catch (err) {
                    this.dhlFiles[i].failed = "Alle";
                    console.error(err);
                }
            }
            this.loading = false;
            this.uploadingState = 0;
          
        },


        async refresh() {
            this.loading = true;
            try {
                this.loading = false;
            } catch (err) {
                if (err.response.status == 401) {
                    router.replace("/auth/login");
                }
            }
        }
    }
};
</script>